<template>
  <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <TreeModel type="device" @on-select-change="onSelectChange" />
      </div>
      <div slot="right" class="demo-split-pane">
        <div class="head-view">{{ headTitle }}</div>
        <div class="btn-view">
          <div class="from-view">
            <div class="from-label">{{ $t('device.index.508393-0') }}</div>
            <Input
              v-model="query.deviceCode"
              :placeholder="$t('device.index.508393-1')"
            ></Input>
          </div>
          <Button
            style="margin-right: 10px"
            type="primary"
            icon="ios-search"
            @click="GetUserDevicesPageV2(1)"
            >{{ $t('device.index.508393-2') }}</Button
          >
          <Button type="success" icon="md-add" @click="importDevice"
            >{{ $t('device.index.508393-3') }}</Button
          >
        </div>
        <VTabel
          :height="height"
          :columns="columns"
          :data="dataList"
          :total="page.total"
          :pageIndex="page.page"
          :loading="loading"
          @onPageChange="onPageChange"
          @onPageSizeChange="onPageSizeChange"
        ></VTabel>
      </div>
    </Split>
    <edit-model
      :show.sync="edit.show"
      v-bind="edit"
      @on-edit="GetUserDevicesPageV2()"
    ></edit-model>
    <add-model
      :show.sync="add.show"
      v-bind="add"
      @on-add="GetUserDevicesPageV2()"
    ></add-model>
    <status-model :show.sync="status.show"
      v-bind="status"></status-model>
  </div>
</template>

<script>
import TreeModel from "../area/mods/tree.vue";
import EditModel from "./mods/edit/index.vue";
import AddModel from "./mods/add/index.vue";
import StatusModel from "./mods/status/index.vue";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";
import api from "../../../../api/request.js";
import Cookies from "js-cookie";
import StateModel from './mods/status/state.vue'

const URL = {
  GetUserDevicesPageV2: "api/CommElecDevice/GetUserDevicesPageV2", // 获取设备列表
  DeleteUserDevice: "api/YhjDevice/DeleteUserDevice", // 删除设备
};

export default {
  components: {
    TreeModel,
    VTabel,
    EditModel,
    AddModel,
    StatusModel,
    StateModel
  },
  data() {
    return {
      height: window.innerHeight - 270,
      split1: 0.2,
      dataList: [],
      loading: false,
      query: {
        deviceCode: "",
        onlineState: "",
      },
      page: {
        page: 1,
        size: 15,
        total: 0,
      },
      parameter: "",
      headTitle: this.$t('device.index.508393-4'),
      edit: {
        show: false,
        data: {},
      },
      add: {
        show: false,
        data: {}
      },
      device: {
        show: false,
      },
      status: {
        show: false,
        data: {}
      }
    };
  },
  computed: {
    columns() {
      return defaultData.columns(this, StateModel);
    },
  },
  mounted() {
    this.getWindowInfo();
    window.addEventListener("resize", this.getWindowInfo);

    const userItem = this.$store.getters.getUserItem
    if (userItem.RoomCode) {
      this.headTitle = userItem.RoomName;
      this.parameter = `&RoomCode=${userItem.RoomCode}`;
    }
    // 获取设备列表
    this.GetUserDevicesPageV2();
  },
  methods: {
    getWindowInfo() {
      this.height = window.innerHeight - 270;
    },
    onPageChange(value) {
      this.page.page = value;
      this.GetUserDevicesPageV2();
    },
    onPageSizeChange(value) {
      this.page.page = 1;
      this.page.size = value;
      this.GetUserDevicesPageV2();
    },
    GetUserDevicesPageV2(page = this.page.page, size = this.page.size) {
      const { GroupCode, DepartmentCode, CompanyCode } = JSON.parse(
        Cookies.get("AdminData")
      );
      this.loading = true;
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetUserDevicesPageV2}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&pageIndex=${page}&pageSize=${size}&deviceCode=${this.query.deviceCode}${this.parameter}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      )
        .then((res) => {
          if (res.Success) {
            this.dataList = res.Data;
            this.page = {
              page,
              size,
              total: res.TotalCount,
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectChange(item) {
      this.parameter = "";
      this.headTitle = item.title;
      this.add.data = {...item}
      switch (item.grade) {
        case 1:
          this.parameter = `&Ccode=${item.Ccode}`;
          break;
        case 2:
          this.parameter = `&Vcode=${item.Vcode}`;
          break;
        case 3:
          this.parameter = `&Scode=${item.Scode}`;
          break;
        case 4:
          this.parameter = `&Zcode=${item.Zcode}`;
          break;
        case 5:
          this.parameter = `&RoomCode=${item.RoomCode}`;
          break;
        default:
          break;
      }
      this.page.page = 1;
      this.GetUserDevicesPageV2();
    },
    // 导入设备
    importDevice() {
      this.add.show = true
    },
    // 删除设备
    removeClick(row) {
      console.log(row);
      let _this = this;
      let data = {
        DeviceCodeList: [row.DeviceCode],
      };
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "post",
          url: URL.DeleteUserDevice,
          data: data,
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      ).then((res) => {
        if (res.Success) {
          _this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          this.page.page = 1;
          this.GetUserDevicesPageV2();
        } else {
          _this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    }
  },
};
</script>

<style scoped>
.demo-split {
  height: 100%;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  height: 100%;
  padding: 10px 20px;
  overflow-y: auto;
}
.head-view {
  height: 40px;
  width: 100%;
  background-color: rgb(243, 245, 249);
  padding-left: 10px;
  line-height: 40px;
}
.btn-view {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
}
.from-view {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.from-label {
  width: 100px;
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/device/index.vue